var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"element-box"},[_c('div',{staticClass:"element-content px-5 pb-5"},[(_vm.userForm)?_c('symForm',{attrs:{"options":_vm.opt,"data":_vm.formData,"form":_vm.userForm,"formProcess":_vm.formProcess},on:{"sended":_vm.matchForm}}):_vm._e()],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3c251e94","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/match/marketForm.vue
// module id = MNk/
// module chunks = 0